import React from 'react';
export function AboutSection() {
  return <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-20 text-center max-w-5xl mx-auto border border-gray-200" data-id="element-1247">
      <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1248">
        <strong className="text-navy" data-id="element-1249">Breton</strong> - a pioneer in the
        development of advanced technologies and materials - has been a world
        leader in the design and manufacture of state-of-the-art industrial
        machinery since 1963. Breton is active in different industrial sectors,
        which need products and services of excellence with high technological
        content, combined with the need of high productivity and quality
        standards. The Machine Tool Division was founded in the early '90s and
        Breton has firmly established itself as one of the most appreciated
        manufacturers of highspeed machines.
      </p>
    </div>;
}